<template>
  <div class="row">
    <div class="col-md-12">
    <legend class="defaultcase">Tax Information</legend>
    <br/>
      <div class="form-group" :class="errorTaxResidency" >
        <label>Tax Residence of Entity</label>
        <select id="tax_residency_entity" class="form-control" name="tax_residency_entity" v-model="formData.tax_residency_entity">
          <option value="" :selected="'' === formData.tax_residency_entity">--Select One--</option>
          <option value="Canada" :selected="'Canada' === formData.tax_residency_entity">Canada</option>
          <option value="United States" :selected="'United States' === formData.tax_residency_entity">United States</option>
          <option value="Other" :selected="'Other' === formData.tax_residency_entity">Other</option>
        </select>
      </div>
    <br/>
    <div v-if="formData.tax_residency_entity === 'United States' || formData.tax_residency_entity === 'Other'" :style="errorHaveTin">
      <label>I have a tax identification number</label>
          <div class="radio radio-primary" >
            <input type="radio" id="have_tin_entity_yes" name="have_tin_entity" value="Yes" class="radio-primary" v-model="formData.have_tin_entity">
            <label>Yes</label>
          </div>
          <div class="radio radio-primary">
            <input type="radio" id="have_tin_entity_no" name="have_tin_entity" value="No" class="radio-primary" v-model="formData.have_tin_entity">
            <label>No</label>
          </div>
    </div>
    <br/>
    <div class="form-group" :class="errorTinNumber" v-if="formData.have_tin_entity === 'Yes' && formData.tax_residency_entity !== 'Canada'">
      <label>TIN Number</label>
      <input type="text" class="form-control" id="tin_number_entity" name="tin_number_entity" v-model="formData.tin_number_entity">
      <br/>
    </div>
    <div class="form-group" :class="errorTaxResidencyOther" v-if="formData.tax_residency_entity === 'Other'">
      <label>Tax Residency Other</label>
      <input type="text" class="form-control" id="tax_residency_other_entity" name="tax_residency_other_entity" v-model="formData.tax_residency_other_entity">
    </div>
    <br/>
    <div class="form-group" :style="errorNoTinReason" v-if="formData.tax_residency_entity === 'United States' && formData.have_tin_entity === 'No'">
      <label>If you do not have a TIN from the United States, have you applied for one?</label>
      <div class="radio radio-primary">
        <input type="radio" id="applied_for_entity_yes" name="no_tin_reason_entity" value="Yes" class="radio-primary" v-model="formData.no_tin_reason_entity">
        <label>I have applied for one.</label>
      </div>
      <div class="radio radio-primary">
        <input type="radio" id="applied_for_entity_no" name="no_tin_reason_entity" value="No" class="radio-primary" v-model="formData.no_tin_reason_entity">
        <label>I have not applied for one.</label>
      </div>
    </div>
      <br/>
    <div v-if="formData.tax_residency_entity === 'Other' && formData.have_tin_entity === 'No'" :style="errorNoTinReason">
      <div class="radio radio-primary">
        <input type="radio" id="no_tin_entity_reason1" name="no_tin_reason_entity" value="Reason 1" class="radio-primary" v-model="formData.no_tin_reason_entity">
        <label>I will apply or have applied for a TIN but have not yet received it</label>
      </div>
      <div class="radio radio-primary">
        <input type="radio" id="no_tin_entity_reason2" name="no_tin_reason_entity" value="Reason 2" class="radio-primary" v-model="formData.no_tin_reason_entity">
        <label>My jurisdiction of tax residence does not issue TIN's to its residents</label>
      </div>
      <div class="radio radio-primary" >
        <input type="radio" id="no_tin_entity_reason3" name="no_tin_reason_entity" value="Reason 3" class="radio-primary" v-model="formData.no_tin_reason_entity">
        <label>Other reason, please specify</label>
      </div>
      <div class="col-md-6">
        <div class="form-group" :class="errorNoTinReasonSpecific">
        <input type="text" class="form-control"  id="reason_specific_entity" name="no_tin_reason_specific_entity" v-model="formData.no_tin_reason_specific_entity">
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "TaxFormEntity",
  props: {
    flowData: '',
    oldData: '',
    errorState: ''
  },
  data() {
    return {
      formData: {
        tax_residency_entity: '',
        have_tin_entity: '',
        tin_number_entity: '',
        tax_residency_other_entity: '',
        no_tin_reason_entity: '',
        no_tin_reason_specific_entity: ''
      },
      hasErrors: {
        tax_residency_entity: false,
        have_tin_entity: false,
        tin_number_entity: false,
        tax_residency_other_entity: false,
        no_tin_reason_entity: false,
        no_tin_reason_specific_entity: false,
      }
    }
  },
  methods: {
    checkErrorState() {
      if(this.errorState !== '') {
        if(this.errorState.tax_residency_entity) {
          this.errorState.tax_residency_entity.length > 0 ? this.hasErrors.tax_residency_entity = true : this.hasErrors.tax_residency_entity = false
        }
        if(this.errorState.have_tin_entity) {
          this.errorState.have_tin_entity.length > 0 ? this.hasErrors.have_tin_entity = true : this.hasErrors.have_tin_entity = false
        }
        if(this.errorState.tin_number_entity) {
          this.errorState.tin_number_entity.length > 0 ? this.hasErrors.tin_number_entity = true : this.hasErrors.tin_number_entity = false
        }
        if(this.errorState.tax_residency_other_entity) {
          this.errorState.tax_residency_other_entity.length > 0 ? this.hasErrors.tax_residency_other_entity = true : this.hasErrors.tax_residency_other_entity = false
        }
        if(this.errorState.no_tin_reason_entity) {
          this.errorState.no_tin_reason_entity.length > 0 ? this.hasErrors.no_tin_reason_entity = true : this.hasErrors.no_tin_reason_entity = false
        }
        if(this.errorState.no_tin_reason_specific_entity) {
          this.errorState.no_tin_reason_specific_entity.length > 0 ? this.hasErrors.no_tin_reason_specific_entity = true : this.hasErrors.no_tin_reason_specific_entity = false
        }
      }

    }
  },
  computed: {
    errorTaxResidency() {
      if(this.hasErrors.tax_residency_entity) {
        return 'error'
      }

      return ''
    },
    errorHaveTin() {
      if(this.hasErrors.have_tin_entity) {
        return "border: solid 2px red; border-radius: 4px;"
      }

      return ''
    },
    errorTinNumber() {
      if(this.hasErrors.tin_number_entity) {
        return 'error'
      }

      return ''
    },
    errorTaxResidencyOther() {
      if(this.hasErrors.tax_residency_other_entity) {
        return 'error'
      }

      return ''
    },
    errorNoTinReason() {
      if(this.hasErrors.no_tin_reason_entity) {
        return "border: solid 2px red; border-radius: 4px;"
      }

      return ''
    },
    errorNoTinReasonSpecific() {
      if(this.hasErrors.no_tin_reason_specific_entity) {
        return "error"
      }

      return '';
    }
  },
  created() {
    this.formData = this.flowData
    if(this.oldData.length !== 0) {
      this.formData = this.oldData
    }
    this.checkErrorState()
  }
}
</script>